<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">Carregando...</p>
</ngx-spinner>

<app-pesquisar-matricula
  *ngIf="matricula == null"
  [titulo]="'Lotações Vinculadas'"
  [inputText]="true"
  (colaboradorEmitter)="matriculaListener($event)"
></app-pesquisar-matricula>

<section class="container" *ngIf="matricula != null">
  <div class="card">
    <div class="card-header">
      <h3 class="card-title font-weight-semibold">
        <i
          class="fa fa-arrow-left pr-3 btn"
          aria-hidden="true"
          (click)="retornarTelaInicial()"
          style="cursor: pointer; bottom: 2px"
        ></i
        >Lotações Vinculadas
      </h3>
    </div>
    <div class="card-body">
      <form #colaborador="ngForm" class="row" [formGroup]="formColaborador">
        <div class="col-md-2 form-group">
          <label class="font-weight-semibold">Matrícula</label>

          <input
            type="text"
            class="form-control"
            placeholder="Matrícula"
            mask="0*"
            formControlName="matricula"
          />

          <span class="form-text" *ngIf="loading"
            >Carregando <i class="fa fa-spinner fa-spin" aria-hidden="false"></i
          ></span>
        </div>

        <div class="col-md-10 form-group">
          <label class="font-weight-semibold">Nome do Colaborador</label>
          <input type="text" class="form-control" placeholder="Nome" formControlName="nome" />
        </div>
      </form>
    </div>
  </div>

  <div class="card d-flex justify-content-center">
    <div class="card-header d-inline-flex justify-content-between">
      <h3 class="card-title font-weight-semibold">Lista de Lotacões</h3>
      <div>
        <button
          type="button"
          class="btn btn-outline-primary ml-3"
          (click)="openModal()"
          data-toggle="modal"
          data-target="#cadastroLotacaoModal"
        >
          <i class="fa fa-plus"></i> Adicionar Lotação
        </button>
      </div>
    </div>
    <div class="card-body table-responsive mt-2">
      <table class="table table-striped border-blue text-left mt-2" *ngIf="listaLotacao.length > 0">
        <thead class="bg-teal-400">
          <tr>
            <th>CPF</th>
            <th>Setor Principal</th>
            <th>Setor Vinculado</th>
            <th>Data Início</th>
            <th>Data Fim</th>

            <th class="text-right" style="padding-right: 110px">Ações</th>
          </tr>
        </thead>

        <tbody *ngFor="let Lotacao of listaLotacao; let i = index">
          <tr>
            <td>{{ Lotacao.CPF }}</td>
            <td>{{ Lotacao.DescricaoSetorPrincipal }}</td>
            <td>{{ Lotacao.DescricaoSetorVinculado }}</td>
            <td>{{ Lotacao.DataInicio.ToDate }}</td>
            <td>{{ Lotacao.DataFim.ToDate || 'Não informado' }}</td>

            <td class="d-flex justify-content-center">
              <button
                type="button"
                class="btn btn-outline-primary mr-2"
                data-toggle="modal"
                data-target="#cadastroLotacaoModal"
                (click)="buscarLotacaoModal(Lotacao.Codigo)"
              >
                <i class="fa fa-pencil"></i>
              </button>
              <button
                type="button"
                [ngClass]="{
                  'btn-outline-primary': Lotacao.Obs === 'N',
                  'btn-primary': Lotacao.Obs === 'S'
                }"
                class="btn mr-2"
                data-toggle="modal"
                data-target="#observacoesLotacaoModal"
                (click)="modalObservacoes.abrirModal(Lotacao)"
              >
                <i class="fa-solid fa-book fa-lg"></i>
              </button>
              <button
                type="button"
                [ngClass]="{
                  'btn-outline-primary': Lotacao.Documento === 'N',
                  'btn-primary': Lotacao.Documento === 'S'
                }"
                class="btn mr-2"
                data-toggle="modal"
                data-target="#anexoLotacaoModal"
                (click)="modalAnexo.abrirModal(Lotacao)"
              >
                <i class="fa fa-file"></i>
              </button>
              <button
                type="button"
                class="btn btn-outline-danger"
                (click)="deletarLotacao(Lotacao)"
              >
                <i class="fa fa-trash"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      <div
        *ngIf="listaLotacao.length === 0"
        class="p-4 d-flex justify-content-center align-items-center"
      >
        <h6 class="font-weight-semibold">Não há dados de Lotação para esse colaborador.</h6>
      </div>
    </div>
  </div>
</section>

<div class="modal fade" id="observacoesLotacaoModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <app-observacoes-ficha-funcional
        (gatilhoAtivado)="buscarLotacao()"
        [colaborador]="colaborador"
        [tipo]="tipoPagina"
      >
      </app-observacoes-ficha-funcional>
    </div>
  </div>
</div>

<div class="modal fade" id="anexoLotacaoModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <app-anexo
        (gatilhoAtivado)="buscarLotacao()"
        [pagina]="tipoPagina"
        [matricula]="colaborador?.Matricula"
        [enviarSeparadamente]="true"
        [modal]="true"
      ></app-anexo>
    </div>
  </div>
</div>

<!-- Modal -->
<div class="modal fade" id="lotacaoModal" tabindex="-1" role="dialog" aria-hidden="true" (hidden.bs.modal)="closeModal()">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ cadastroLotacao ? 'Adicionar Lotação' : 'Editar Lotação' }}</h5>
        <button type="button" class="close" (click)="closeModal()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body">
        <form [formGroup]="formLotacao" (ngSubmit)="salvarLotacao()">
          <div class="form-group">
            <label for="CodigoLoteModal">Lotação</label>
            <select
              class="form-control"
              id="CodigoLoteModal"
              formControlName="CodigoLoteModal"
              [attr.disabled]="!cadastroLotacao ? '' : null"
              [ngClass]="{
                'is-invalid':
                  formLotacao.get('CodigoLoteModal')?.invalid &&
                  formLotacao.get('CodigoLoteModal')?.touched
              }"
            >
              <option [value]="null">Selecione uma lotação</option>
              <option *ngIf="carregandoLotacoes" value="" disabled>Carregando lotações...</option>
              <option *ngFor="let tipo of tiposLotacao" [value]="tipo.Codigo?.toString()">
                {{ tipo.Nome }} ({{ tipo.Codigo }})
              </option>
            </select>

            <div
              *ngIf="
                formLotacao.get('CodigoLoteModal')?.hasError('required') &&
                formLotacao.get('CodigoLoteModal')?.touched
              "
              class="text-danger"
            >
              Campo Obrigatório.
            </div>
          </div>

          <div class="form-group">
            <label for="DataInicioModal">Data Inícial</label>
            <input
              type="date"
              class="form-control"
              id="DataInicioModal"
              formControlName="DataInicioModal"
              [ngClass]="{
                'is-invalid':
                  formLotacao.get('DataInicioModal')?.invalid &&
                  formLotacao.get('DataInicioModal')?.touched
              }"
            />

            <div
              *ngIf="
                formLotacao.get('DataInicioModal')?.hasError('required') &&
                formLotacao.get('DataInicioModal')?.touched
              "
              class="text-danger"
            >
              Campo Obrigatório.
            </div>
          </div>

          <div class="form-group">
            <label for="DataFimModal">Data Fim (Opcional)</label>
            <input
              type="date"
              class="form-control"
              id="DataFimModal"
              formControlName="DataFimModal"
            />
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" (click)="closeModal()">Cancelar</button>
            <button type="submit" class="btn btn-primary">
              {{ cadastroLotacao ? 'Salvar' : 'Atualizar' }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
